import { FC } from "react";
import RestrictedPage from "@/consumer/restrictedPage";
import MailTemplateMainTable from "@/components/mailTemplate/mailTemplateMainTable";

const MailTemplateList: FC = () => {
  return (
    <RestrictedPage permissionRequired="frontend_view_email_template">
      <MailTemplateMainTable />
    </RestrictedPage>
  );
};

export default MailTemplateList;
